import { render, staticRenderFns } from "./AuctionBidsGrid.vue?vue&type=template&id=58046dae"
import script from "./AuctionBidsGrid.vue?vue&type=script&lang=js"
export * from "./AuctionBidsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports